import { API_AUTH, setTokenGlobal } from "../common";
import { Cookies } from "react-cookie";
import { getDomain } from "utils/utils";

var urlNew = getDomain();
const cookies = new Cookies();
var token = cookies.get("userTokenDaiLy");
if (typeof token != "undefined" && token.length > 6) {
  token = token.substring(6);
  setTokenGlobal(token, urlNew);
}
export default {
  getDanhSachCongThucSanPham: () =>
    API_AUTH.get("congthucsanpham/getDanhSachCongThucSanPham"),
  saveCongThucSanPham: (congthucid, tencongthuc, congthuc, donvitinh) =>
    API_AUTH.post(
      "congthucsanpham/saveCongThucSanPham?congthucid=" +
      congthucid +
      "&tencongthuc=" +
      tencongthuc +
      "&congthuc=" +
      congthuc +
      "&attributeid=" +
      donvitinh
    ),
  delCongThucSanPham: (congthucid) =>
    API_AUTH.post(
      "congthucsanpham/delCongThucSanPham?congthucid=" + congthucid
    ),
  getCongThucTheoSanPham: (congthucId) =>
    API_AUTH.get(
      "congthucsanpham/getCongThucTheoSanPham?congthucId=" + congthucId
    ),
  getKetQuaCongThuc: (params) =>
    API_AUTH.post("congthucsanpham/getKetQuaCongThuc", params),
  getOptionPriceByOptionID: (tukhoa) =>
    API_AUTH.get(`categoryPrice/GetOptionPriceByOptionID${tukhoa.params}`, {}),
};
